import {
  AggregatedQueryProps,
  QueryAggregator,
  QueryOrQueryAggregator,
} from "./QueryAggregator"

/**
 * Wraps a provided Query or QueryAggregator instance and transform its
 * result using the 'mapperFunction'
 *
 * @returns QueryAggregator
 */

export const mapQueryResult = <T extends QueryOrQueryAggregator, V>(
  query: T,
  mapperFunction: (query: T) => V,
): AggregatedQueryProps<V> => {
  const queries = new QueryAggregator()
  queries.add(query)

  return queries
    .setDataFunction(() => mapperFunction(query))
    .getAggregate() as AggregatedQueryProps<V>
}

/**
 * Wraps a provided array of queries or QueryAggregator instance and transform its
 * result using the 'mapperFunction'
 *
 * @returns QueryAggregator
 */

export const mapQueriesResult = <T extends QueryOrQueryAggregator, V>(
  queryArray: T[],
  mapperFunction: (queryArray: T[]) => V,
): AggregatedQueryProps<V> => {
  const queries = new QueryAggregator()
  queryArray.forEach((query) => {
    queries.add(query)
  })

  return queries
    .setDataFunction(() => mapperFunction(queryArray))
    .getAggregate() as AggregatedQueryProps<V>
}
